"use client";
import { jsxs as i, jsx as l } from "react/jsx-runtime";
const d = ({
  title: a,
  titleId: c,
  desc: r,
  descId: h,
  ...t
}) => /* @__PURE__ */ i(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    width: 24,
    height: 24,
    "aria-labelledby": c,
    "aria-describedby": h,
    ...t,
    children: [
      r ? /* @__PURE__ */ l("desc", { id: h, children: r }) : null,
      a ? /* @__PURE__ */ l("title", { id: c, children: a }) : null,
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M38.0576 24.9522a.747.747 0 0 1-.4522-.1524.75.75 0 0 1-.1455-1.0508l8.8003-11.621H15.5244l8.2969 10.9726c.25.33.1845.8008-.146 1.0508-.3301.247-.8008.1836-1.0503-.1465l-9.2061-12.1748a.749.749 0 0 1-.0732-.7861.749.749 0 0 1 .6713-.416h33.752c.2847 0 .545.161.6714.416a.75.75 0 0 1-.0732.787l-9.711 12.8243a.751.751 0 0 1-.5986.2969"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M32.5537 28.0762a.75.75 0 0 1-.19-.0244c-.4009-.1045-.6406-.5147-.5361-.915l3.919-15.0089H26.039l2.9302 11.2354a.75.75 0 0 1-1.4512.3789l-3.1753-12.1748a.752.752 0 0 1 .1324-.6484.749.749 0 0 1 .5932-.291h11.6494a.749.749 0 0 1 .5938.292.75.75 0 0 1 .1318.6474l-4.1645 15.9482a.7504.7504 0 0 1-.7251.5606"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M47.7724 12.128h-33.752a.75.75 0 0 1-.6762-.4259.75.75 0 0 1 .0918-.7939l5.5259-6.8701a.749.749 0 0 1 .5844-.2803h22.6973c.227 0 .442.1025.5845.2793l5.5288 6.8701a.751.751 0 0 1 .0918.795.75.75 0 0 1-.6763.4257m-32.186-1.5H46.206l-4.3218-5.3702H19.9057z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M36.7153 12.128H25.039a.749.749 0 0 1-.6806-.4356.749.749 0 0 1 .1093-.7998l5.838-6.8701c.2841-.336.8583-.336 1.1425 0l5.8384 6.87a.749.749 0 0 1 .1094.7999.75.75 0 0 1-.6807.4355m-10.0547-1.5h8.4331L30.877 5.666z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M25.0737 12.128H14.019a.75.75 0 0 1-.6763-.4259.75.75 0 0 1 .0918-.7939l5.5274-6.8701c.2851-.3555.8838-.3555 1.169 0l5.5273 6.8701a.75.75 0 0 1 .0918.794.75.75 0 0 1-.6763.4257m-9.4888-1.5h7.9229L19.5464 5.704zM47.771 12.128H36.7163a.75.75 0 0 1-.6763-.4259.75.75 0 0 1 .0918-.7939l5.5273-6.8701c.2852-.3555.8838-.3555 1.169 0l5.5273 6.8701a.75.75 0 0 1 .0918.794.75.75 0 0 1-.6762.4257m-9.4888-1.5h7.9228L42.2436 5.704z"
        }
      ),
      /* @__PURE__ */ l("path", { d: "M31.6523 28.583a.7499.7499 0 0 1-.3701-1.4023l10.2153-5.79c2.1543-1.3048 4.9185-1.085 6.858.5556.4189.3545.6552.872.6484 1.42a1.828 1.828 0 0 1-.6812 1.4042l-1.399 1.128c-.3231.2578-.7943.208-1.0546-.1133-.2598-.3223-.2095-.795.1133-1.0547l1.398-1.128a.325.325 0 0 0 .1235-.2539.327.327 0 0 0-.1177-.2578c-1.4468-1.2246-3.5098-1.3857-5.1309-.4062l-10.2339 5.8008a.744.744 0 0 1-.369.0976" }),
      /* @__PURE__ */ l("path", { d: "M14.622 40.8603a.7507.7507 0 0 1-.6601-.3936l-5.1445-9.536a.751.751 0 0 1 .1713-.9258l2.0665-1.7754c.3154-.2686.7885-.2324 1.0576.081.27.3135.2339.7871-.0801 1.0577L10.4243 30.75l4.4346 8.2197c1.996-1.5498 4.4843-2.4033 7.0205-2.4033h7.1342c1.4825 0 2.9366-.5156 4.0952-1.4521l10.5699-8.5264c.3222-.2578.7944-.208 1.0542.1133a.7496.7496 0 0 1-.1128 1.0547l-10.5689 8.5253c-1.4238 1.1514-3.2133 1.7852-5.0376 1.7852h-7.1342c-2.25 0-4.4561.7725-6.212 2.1758l-.5815.458a.752.752 0 0 1-.4639.1601" }),
      /* @__PURE__ */ l("path", { d: "M29.292 29.8906h-7.2374c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h7.2373c1.127 0 2.0435-.916 2.0435-2.043s-.9165-2.0439-2.0435-2.0439h-8.1547c-.104-.003-3.2027-.2695-5.7266 2.1611l-.9014.7764c-.314.2695-.7876.2334-1.0576-.081-.27-.3135-.2339-.7871.08-1.0577l.8697-.747c3.0088-2.9004 6.6558-2.5625 6.8125-2.5479l8.0782-.0039c1.954 0 3.5434 1.5898 3.5434 3.544 0 1.953-1.5893 3.543-3.5434 3.543M9.23 46.2422a1.45 1.45 0 0 1-.4112-.0606 1.421 1.421 0 0 1-.8477-.6894L1.168 32.871c-.1811-.335-.2207-.7207-.1113-1.086s.3545-.667.6904-.8476l5.5503-2.9922c.335-.1826.7212-.2207 1.0864-.1113.3658.1094.667.3554.8477.6914l6.8032 12.6191a1.416 1.416 0 0 1 .1104 1.0889 1.417 1.417 0 0 1-.691.8457l-5.5488 2.9912a1.414 1.414 0 0 1-.6753.1719M2.5223 32.2236l6.7344 12.4922 5.4419-2.9336-6.7534-12.4824z" }),
      /* @__PURE__ */ l("path", { d: "M10.3725 41.5645c-.7026 0-1.274-.5713-1.274-1.2735 0-.7031.5714-1.2744 1.274-1.2744s1.274.5713 1.274 1.2744c0 .7022-.5713 1.2735-1.274 1.2735m0-1.5a.2266.2266 0 0 0-.226.2265c0 .248.4521.248.4521 0a.2266.2266 0 0 0-.226-.2265" })
    ]
  }
);
export {
  d as default
};
